module.exports = __webpack_public_path__ + "912babe284f089f3196ade4eb3981a4f.pdf";